import { DateUtils } from 'react-day-picker';

const addMonths = (day: Date, nOfMonths: number) =>
  DateUtils.addMonths(day, nOfMonths);

export default addMonths;
